module.exports = __webpack_public_path__ + "static/media/utensil-spoon.dcd53bec.svg";